module.exports = __webpack_public_path__ + "media/images/icons/scan-348f43711764851d5dc62202bd121e36.svg";